import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@examdojo/core/environment';
import { SolutionPath } from '@examdojo/models/markscheme-v2';
import { QuestionItemV2 } from '@examdojo/models/question';

@Injectable({ providedIn: 'root' })
export class QuestionItemsStemMarkschemeHttpService {
  constructor(private readonly http: HttpClient) {}

  generateSolutionPath(questionItems: QuestionItemV2[], referenceQuestionId: number, stemId: number) {
    const url = `${environment.examdojo.examdojoApiUrl}/review/reference-questions/${referenceQuestionId}/generate-solution-paths`;

    return this.http.post<SolutionPath[]>(url, {
      question_items: questionItems,
      stem_id: stemId,
    });
  }
}
